/* =========================================================================
   Custom zoom cursor for product drawer images.
   The OUTER wrapper follows the pointer instantly (no smoothing) — same feel
   as the native cursor. The INNER circle handles the smooth fade/scale on
   hover-in / hover-out via CSS transitions.
   ========================================================================= */
(function () {
  'use strict';

  const SELECTOR = '.product-drawer__figure, .product-drawer__media-item';
  const cursor = document.querySelector('[data-pd-cursor]');
  if (!cursor) return;

  if (window.matchMedia('(hover: none), (pointer: coarse)').matches) {
    cursor.style.display = 'none';
    return;
  }

  let hoveredTarget = null;
  // Offset of the cursor's nearest transformed ancestor (e.g. the dialog).
  // CSS `position: fixed` becomes relative to a transformed ancestor, so we
  // subtract its origin from viewport-space mouse coords before applying.
  let parentOffsetX = 0;
  let parentOffsetY = 0;
  let pendingFrame = null;
  let latestX = 0;
  let latestY = 0;

  function recalcParentOffset() {
    const parent = cursor.parentElement;
    if (!parent || parent === document.body || parent === document.documentElement) {
      parentOffsetX = 0;
      parentOffsetY = 0;
      return;
    }
    const rect = parent.getBoundingClientRect();
    parentOffsetX = rect.left;
    parentOffsetY = rect.top;
  }
  window.addEventListener('resize', recalcParentOffset, { passive: true });

  function applyPosition() {
    pendingFrame = null;
    const x = Math.round(latestX - parentOffsetX);
    const y = Math.round(latestY - parentOffsetY);
    cursor.style.transform =
      'translate3d(' + x + 'px, ' + y + 'px, 0) translate(-50%, -50%)';
  }

  function onMove(event) {
    latestX = event.clientX;
    latestY = event.clientY;
    if (pendingFrame === null) {
      pendingFrame = requestAnimationFrame(applyPosition);
    }
  }

  function isZoomTarget(el) {
    if (!el || el.nodeType !== 1) return null;
    return el.closest(SELECTOR);
  }

  function onOver(event) {
    const target = isZoomTarget(event.target);
    if (!target) return;
    if (target === hoveredTarget) return;
    if (hoveredTarget) hoveredTarget.classList.remove('is-zoom-target');
    hoveredTarget = target;
    hoveredTarget.classList.add('is-zoom-target');

    // Re-measure parent in case the cursor was just moved into the dialog.
    recalcParentOffset();
    // Snap to current mouse coords immediately so the cursor appears under
    // the pointer, not at its previous resting position.
    applyPosition();

    cursor.classList.add('is-active');
  }

  function onOut(event) {
    if (!hoveredTarget) return;
    const next = isZoomTarget(event.relatedTarget);
    if (next === hoveredTarget) return;
    hoveredTarget.classList.remove('is-zoom-target');
    hoveredTarget = null;
    cursor.classList.remove('is-active');
  }

  function onMouseDown() {
    if (hoveredTarget) cursor.classList.add('is-zooming');
  }
  function onMouseUp() {
    cursor.classList.remove('is-zooming');
  }

  document.addEventListener('mousemove', onMove, { passive: true });
  document.addEventListener('mouseover', onOver);
  document.addEventListener('mouseout', onOut);
  document.addEventListener('mousedown', onMouseDown);
  document.addEventListener('mouseup', onMouseUp);
})();
